<template>
  <v-container>
    <v-card class="mx-auto" max-width="900">
      <v-card-title class="headline">
        Gestión de Fechas Proyectadas de Módulos
      </v-card-title>
      <v-card-text>
        <p>
          Seleccione un programa para ver sus módulos y asignar las fechas de inicio proyectadas.
        </p>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="programaSeleccionado"
              :items="programas"
              item-text="nombre_compuesto"
              item-value="id"
              label="Seleccione un Programa"
              outlined
              dense
              return-object
              :loading="loadingProgramas"
              @change="cargarModulos"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          v-if="programaSeleccionado"
          :headers="headers"
          :items="modulos"
          :loading="loadingModulos"
          loading-text="Cargando módulos..."
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.fecha_inicio_proyectada="{ item }">
            <v-menu
              v-model="item.menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.fecha_inicio_proyectada"
                  label="Fecha de Inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.fecha_inicio_proyectada"
                @input="item.menu = false"
                no-title
                scrollable
                locale="es"
              ></v-date-picker>
            </v-menu>
          </template>
        </v-data-table>

      </v-card-text>

      <v-card-actions v-if="programaSeleccionado">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="guardando"
          @click="guardarFechas"
        >
          <v-icon left>mdi-content-save</v-icon>
          Guardar Cambios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FechasProyectadas',
  data() {
    return {
      programas: [],
      programaSeleccionado: null,
      modulos: [],
      loadingProgramas: false,
      loadingModulos: false,
      guardando: false,
      headers: [
        { text: 'Nº Módulo', value: 'numero', sortable: true, width: '10%' },
        { text: 'Nombre del Módulo', value: 'nombre', sortable: false },
        { text: 'Fecha de Inicio Proyectada', value: 'fecha_inicio_proyectada', sortable: false, width: '35%' },
      ],
    };
  },
  mounted() {
    this.cargarProgramas();
  },
  methods: {
    async cargarProgramas() {
      this.loadingProgramas = true;
      try {
        // Reemplazar con la URL real de tu API
        const response = await axios.get('/api/v1/programas-con-modulos');
        this.programas = response.data;
      } catch (error) {
        // console.error('Error al cargar programas:', error);
        this.$root.$notify.show('Error al cargar la lista de programas.', { color: 'red' });
      } finally {
        this.loadingProgramas = false;
      }
    },
    async cargarModulos() {
      if (!this.programaSeleccionado) {
        this.modulos = [];
        return;
      }
      this.loadingModulos = true;
      try {
        // Reemplazar con la URL real de tu API
        const response = await axios.get(`/api/v1/programas/${this.programaSeleccionado.id}/modulos-con-fechas`);
        this.modulos = response.data.map(m => ({ ...m, menu: false })); // Añadir 'menu' para el v-date-picker
      } catch (error) {
        // console.error('Error al cargar módulos:', error);
        this.$root.$notify.show('Error al cargar los módulos del programa.', { color: 'red' });
      } finally {
        this.loadingModulos = false;
      }
    },
    async guardarFechas() {
      this.guardando = true;
      try {
        const payload = this.modulos
          .filter(m => m.fecha_inicio_proyectada) // Enviar solo los que tienen fecha
          .map(m => ({
            modulo_id: m.id,
            fecha_inicio_proyectada: m.fecha_inicio_proyectada,
          }));

        if (payload.length === 0) {
          this.$root.$notify.show('No hay fechas para guardar.', { color: 'info' });
          return;
        }

        // Reemplazar con la URL real de tu API
        await axios.post('/api/v1/programas/fechas-proyectadas', payload);

        this.$root.$notify.show('Fechas proyectadas guardadas con éxito.', { color: 'green' });
      } catch (error) {
        // console.error('Error al guardar las fechas:', error);
        this.$root.$notify.show('Error al guardar las fechas proyectadas.', { color: 'red' });
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>